"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViperFormattedTextEditorWidget = void 0;
const react_1 = __importStar(require("react"));
const utils_1 = require("@rjsf/utils");
const viper_react_1 = require("@squiz/viper-react");
const viper_formatted_text_transformer_1 = require("@squiz/viper-formatted-text-transformer");
const transformer = new viper_formatted_text_transformer_1.ViperFormattedTextTransformer();
const ViperFormattedTextEditorWidget = ({ disabled, formData, onChange, idSchema }) => {
    const attributes = {
        'aria-describedby': (0, utils_1.ariaDescribedByIds)(idSchema),
        'aria-labelledby': (0, utils_1.titleId)(idSchema),
    };
    const handleChange = (0, react_1.useCallback)((event) => {
        onChange(event.value);
    }, []);
    return (react_1.default.createElement(viper_react_1.Viper, { value: formData, disabled: disabled, onChange: handleChange, transformer: transformer, inputAttributes: attributes }));
};
exports.ViperFormattedTextEditorWidget = ViperFormattedTextEditorWidget;
